/**
 * @ignore
 */
export const Box2dToPixi = 30;

/**
 * @ignore
 */
export const PixiToBox2d = 1 / Box2dToPixi;